import { makeObservable, observable, action } from 'mobx';

export default class Home {
  id = Math.random();

  finished = false;

  constructor() {
    makeObservable(this, {
      finished: observable,
      toggle: action,
    });
  }

  toggle() {
    this.finished = !this.finished;
  }
}

export const HomeStore = new Home();
